module.exports = __webpack_public_path__ + "img/司法有效@2x.871e102f.png";